// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
.PortalModal_wrapper__d8JAA {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.2666666667);
  width: 100%;
  height: 100%;
  z-index: 100000;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  animation-duration: 0.3s;
  overflow-y: auto;
}
.PortalModal_wrapper__d8JAA[data-show=true] {
  animation-name: PortalModal_wrapper-show__08EHh;
}
.PortalModal_wrapper__d8JAA[data-show=false] {
  animation-name: PortalModal_wrapper-hide__ftZll;
  opacity: 0;
}

.PortalModal_modal__YC7vB {
  min-width: 10rem;
  background-color: white;
  margin: 1rem;
  animation-duration: 0.3s;
}
.PortalModal_modal__YC7vB[data-show=true] {
  animation-name: PortalModal_modal-show__Mhjm5;
}
.PortalModal_modal__YC7vB[data-show=false] {
  animation-name: PortalModal_modal-hide__BX70A;
  opacity: 0;
}

@keyframes PortalModal_wrapper-show__08EHh {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes PortalModal_wrapper-hide__ftZll {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes PortalModal_modal-show__Mhjm5 {
  0% {
    translate: 0px -10px;
    opacity: 0;
  }
  100% {
    translate: 0px 0px;
    opacity: 1;
  }
}
@keyframes PortalModal_modal-hide__BX70A {
  0% {
    translate: 0px 0px;
    opacity: 1;
  }
  100% {
    translate: 0px 10px;
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/components/PortalModal/PortalModal.module.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;ACvBA;EACE,eAAA;EACA,6CAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EAEA,aAAA;EACA,uBAAA;EACA,uBAAA;EAEA,wBAAA;EACA,gBAAA;AAaF;AAXE;EACE,+CAAA;AAaJ;AAVE;EACE,+CAAA;EACA,UAAA;AAYJ;;AARA;EACE,gBAAA;EACA,uBAAA;EACA,YAAA;EAEA,wBAAA;AAUF;AARE;EACE,6CAAA;AAUJ;AAPE;EACE,6CAAA;EACA,UAAA;AASJ;;AALA;EACE;IAAI,UAAA;EASJ;EARA;IAAM,UAAA;EAWN;AACF;AAVA;EACE;IAAI,UAAA;EAaJ;EAZA;IAAM,UAAA;EAeN;AACF;AAdA;EACE;IACE,oBAAA;IACA,UAAA;EAgBF;EAdA;IACE,kBAAA;IACA,UAAA;EAgBF;AACF;AAdA;EACE;IACE,kBAAA;IACA,UAAA;EAgBF;EAdA;IACE,mBAAA;IACA,UAAA;EAgBF;AACF","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n.wrapper {\n  position: fixed;\n  background-color: rgba(0, 0, 0, 0.2666666667);\n  width: 100%;\n  height: 100%;\n  z-index: 100000;\n  top: 0;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  animation-duration: 0.3s;\n  overflow-y: auto;\n}\n.wrapper[data-show=true] {\n  animation-name: wrapper-show;\n}\n.wrapper[data-show=false] {\n  animation-name: wrapper-hide;\n  opacity: 0;\n}\n\n.modal {\n  min-width: 10rem;\n  background-color: white;\n  margin: 1rem;\n  animation-duration: 0.3s;\n}\n.modal[data-show=true] {\n  animation-name: modal-show;\n}\n.modal[data-show=false] {\n  animation-name: modal-hide;\n  opacity: 0;\n}\n\n@keyframes wrapper-show {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes wrapper-hide {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes modal-show {\n  0% {\n    translate: 0px -10px;\n    opacity: 0;\n  }\n  100% {\n    translate: 0px 0px;\n    opacity: 1;\n  }\n}\n@keyframes modal-hide {\n  0% {\n    translate: 0px 0px;\n    opacity: 1;\n  }\n  100% {\n    translate: 0px 10px;\n    opacity: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `PortalModal_wrapper__d8JAA`,
	"wrapper-show": `PortalModal_wrapper-show__08EHh`,
	"wrapper-hide": `PortalModal_wrapper-hide__ftZll`,
	"modal": `PortalModal_modal__YC7vB`,
	"modal-show": `PortalModal_modal-show__Mhjm5`,
	"modal-hide": `PortalModal_modal-hide__BX70A`
};
export default ___CSS_LOADER_EXPORT___;
